import { Box, FormControl, InputLabel, Select, MenuItem, TextField, Autocomplete } from "@mui/material";
import { ControlInput, IMenuItem } from "../modules/charts/types";

import { aggregationItems } from "../modules/charts/common";

interface ControlInputFieldProps {
  readonly colItems: IMenuItem[];
  readonly input: ControlInput;
  readonly values: any;
  readonly changeValue: (_id: any, _value: any) => void;
  readonly onLabelFocus: () => void;
}

export default function ControlInputField({
  colItems,
  input,
  values,
  changeValue,
  onLabelFocus,
}: ControlInputFieldProps) {
  const { id, type, label, required } = input;
  const menuItems = id === "aggregation" ? aggregationItems : colItems;

  function onChange(e: any) {
    changeValue(id, e.target.value);
  }

  function renderInputField() {
    if (type === "select") {
      return (
        <FormControl sx={{ width: "100%" }}>
          <InputLabel size="small" id={`${id}-label`} required={required}>
            {label}
          </InputLabel>
          <Select
            id={`${id}`}
            labelId={`${id}-label`}
            label={label}
            size="small"
            value={values[id]}
            required={required}
            onChange={onChange}
            fullWidth
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {menuItems.map((menuItem) => (
              <MenuItem key={menuItem.value} value={menuItem.value}>
                {menuItem.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    }
    
    if (type === "multi-select") {
      return (
        <Autocomplete
          multiple
          id={`${id}`}
          size="small"
          options={menuItems}
          getOptionLabel={(option) => option.label}
          filterSelectedOptions
          value={values[id]}
          onChange={(event: any, newValue: any) => {
            changeValue(id, newValue);
          }}
          renderInput={(params) => (
            <TextField required={required} {...params} label={label} />
          )}
        />
      );
    }
    
    return (
      <TextField
        id={`${id}`}
        label={label}
        variant="outlined"
        size="small"
        value={values[id]}
        onChange={onChange}
        onFocus={onLabelFocus}
        required={required}
        fullWidth
      />
    );
  }

  return (
    <Box>
      {renderInputField()}
    </Box>
  );
}
